import { Article, SubregionOverviewData } from 'types/subregion';
import { spotReportPath } from './urls';

interface SubregionProps {
  data: SubregionOverviewData | null;
  feedArticles: Array<Article>;
  primarySpotId: string | null;
}

const getSpotPageRedirectURL = ({ data, feedArticles, primarySpotId }: SubregionProps) => {
  let path = '';
  if (feedArticles?.length === 0) {
    const spotDetails = data?.spots?.filter((spot) => spot?._id === primarySpotId);
    path = spotReportPath(
      {},
      {
        _id: spotDetails?.[0]?._id || '',
        name: spotDetails?.[0]?.name || 'spot',
      },
    );
  }
  return path;
};

export default getSpotPageRedirectURL;
